import {ROUTES} from '@/config/constants'
import {useAuth} from '@/hooks/useAuth'
import {isAdminRole} from '@/types/UserRole'
import {Navigate, Outlet} from 'react-router-dom'

/**
 * Restricts the nested routes to admin users.
 * Must be nested inside `ProtectedRoutes`, which already handles authentication.
 */
export const AdminRoute = () => {
  const {isAuthenticated, userRole} = useAuth()

  // userRole is resolved together with the access token; wait for it before deciding
  if (!isAuthenticated) return null

  if (!isAdminRole(userRole)) {
    return <Navigate to={ROUTES.ERROR_403} replace />
  }

  return <Outlet />
}
